import { Box, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { formatMoney } from '../../../utils/formatters/formatMoney';
import useStyles from './styles';
import { assetUrl } from '../../../utils';

export interface carProps {
  id: number;
  name: string;
  brand: string;
  km: number;
  price: string;
  thumbnail: string;
  year: number;
  yearModel: number;
}

export interface car {
  car: carProps;
}

const CardCar = ({ car }: car) => {
  const classes = useStyles();

  console.log('ass')
  return (
    <Link
      className={classes.container}
      to={`/frotas/descricao-veiculo/${car.id}`}
    >
      <img className={classes.imageCar} src={assetUrl(car.thumbnail)} alt={car.name} />
      <Box className={classes.description}>
        <strong style={{ textTransform: 'uppercase' }}>{car.brand}</strong>
        <Typography className={classes.carName}>{car.name}</Typography>
        <p className={classes.carKm}>
          {car.km} Km - {car.yearModel}/{car.year}
        </p>
        <Typography className={classes.carName}>
          {formatMoney(car.price as any)}
        </Typography>
      </Box>
    </Link>
  );
};

export default CardCar;
